export function assert(value: any, message: string | Error = 'Assert failed.'): asserts value {
  if (value == null) {
    const err = message instanceof Error ? message : new Error(message);
    throw err;
  }
}
